<!-- Toolbar -->
<div class="bg-base-100 rounded-box border-base-200 mb-4 flex w-full flex-wrap gap-2 p-2">
	<button
		[cdkMenuTriggerFor]="newMenu"
		class="btn btn-primary btn-sm gap-2"
	>
		<tw-add class="size-5"></tw-add>
		<span [translate]>New</span>
	</button>
	<ng-template #newMenu>
		<div
			class="menu bg-base-100 rounded-box border-base-200 min-w-48 border p-2 shadow-xl"
			cdkMenu
		>
			@for (action of createActions; track action.label) {
				@if (action.label !== 'Upload File') {
					<button
						cdkMenuItem
						class="hover:bg-base-200 flex w-full items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium transition-colors"
						(click)="handleCreateAction(action)"
					>
						@if (action.iconComponent) {
							<span class="size-5">
								<ng-container *ngComponentOutlet="action.iconComponent"></ng-container>
							</span>
						} @else if (action.iconSafe) {
							<span
								class="size-5"
								[innerHTML]="action.iconSafe"
							></span>
						}
						<span> {{ action.label | translate | async }}</span>
					</button>
				}
			}
		</div>
	</ng-template>

	@for (action of createActions; track action.label) {
		@if (action.label === 'Upload File') {
			<button
				class="btn btn-sm"
				(click)="handleCreateAction(action)"
			>
				@if (action.iconComponent) {
					<span class="size-5">
						<ng-container *ngComponentOutlet="action.iconComponent"></ng-container>
					</span>
				} @else if (action.iconSafe) {
					<span
						class="size-5"
						[innerHTML]="action.iconSafe"
					></span>
				}
				<span>{{ action.label | translate | async }} </span>
			</button>
		}
	}
</div>

<!-- Main content: table + preview panel -->
<div class="flex gap-4">
	<!-- Table section -->
	<div class="bg-base-100 rounded-box border-base-200 min-w-0 flex-1 overflow-x-auto border shadow">
		<table class="table w-full">
			<thead class="bg-base-200/50">
				<tr>
					<th class="w-12"></th>
					<th>Name</th>
					@if (hasTypeBadgeColumn) {
						<th class="hidden md:table-cell">Type</th>
					}
					@if (hasSizeColumn) {
						<th class="hidden lg:table-cell">Size</th>
					}
					@if (hasDateColumn) {
						<th class="hidden lg:table-cell">Modified</th>
					}
					<th class="w-12"></th>
					<th>Actions</th>
					<th class="w-12"></th>
				</tr>
			</thead>
			<tbody>
				<!-- Subfolders -->
				@for (folder of subfolders(); track folder.id) {
					<tr
						class="hover group cursor-pointer"
						[routerLink]="folder.link || []"
						[queryParams]="folder.link ? null : { folderId: folder.id }"
					>
						<td class="text-xl">
							@if (folder.iconComponent) {
								<span class="text-primary block size-6">
									<ng-container *ngComponentOutlet="folder.iconComponent"></ng-container>
								</span>
							} @else {
								<tw-folder class="text-primary size-6"></tw-folder>
							}
						</td>
						<td>
							<div class="text-base-content font-bold">{{ folder.name }}</div>
						</td>
						@if (hasTypeBadgeColumn) {
							<td class="text-base-content/40 hidden md:table-cell">—</td>
						}
						@if (hasSizeColumn) {
							<td class="text-base-content/40 hidden lg:table-cell">—</td>
						}
						@if (hasDateColumn) {
							<td class="text-base-content/40 hidden lg:table-cell">—</td>
						}
						<td>
							@if (!folder.link) {
								<button
									class="btn btn-ghost btn-sm btn-square"
									(click)="shareFolder(folder); $event.stopPropagation()"
									title="Share"
								>
									<svg
										xmlns="http://www.w3.org/2000/svg"
										fill="none"
										viewBox="0 0 24 24"
										stroke-width="1.5"
										stroke="currentColor"
										class="size-5"
									>
										<path
											stroke-linecap="round"
											stroke-linejoin="round"
											d="M7.217 10.907a2.25 2.25 0 1 0 0 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186 9.566-5.314m-9.566 7.5 9.566 5.314m0 0a2.25 2.25 0 1 0 3.935 2.186 2.25 2.25 0 0 0-3.935-2.186Zm0-12.814a2.25 2.25 0 1 0 3.933-2.185 2.25 2.25 0 0 0-3.933 2.185Z"
										/>
									</svg>
								</button>
							}
						</td>
						<td>
							<button class="btn btn-ghost btn-xs">Open</button>
						</td>
						<td>
							<button
								(click)="$event.stopPropagation()"
								[cdkMenuTriggerFor]="menuFolderTpl"
								class="btn btn-square btn-ghost btn-sm"
							>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									fill="none"
									viewBox="0 0 24 24"
									stroke-width="1.5"
									stroke="currentColor"
									class="size-5"
								>
									<path
										stroke-linecap="round"
										stroke-linejoin="round"
										d="M12 6.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5ZM12 12.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5ZM12 18.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5Z"
									/>
								</svg>
							</button>
							<ng-template #menuFolderTpl>
								<ul
									class="menu bg-base-100 rounded-box border-base-200 w-56 border p-2 shadow-xl"
									cdkMenu
								>
									<li
										cdkMenuItem
										class="disabled"
									>
										<span class="text-xs opacity-50">ID: {{ folder.id }}</span>
									</li>
								</ul>
							</ng-template>
						</td>
					</tr>
				}

				<!-- Resources -->
				@for (resource of resources(); track resource.id || $index) {
					<tr
						class="hover group cursor-pointer"
						[class.bg-primary/5]="selectedResource()?.id === resource.id"
						(click)="selectResource(resource)"
					>
						@let def = getDefinition(resource._explorerKind);
						<td
							class="text-xl"
							[title]="resource._explorerKind"
						>
							@if (getIconComponent(resource)) {
								<ng-container *ngComponentOutlet="getIconComponent(resource)"></ng-container>
							} @else {
								<span [innerHTML]="getIcon(resource)"></span>
							}
						</td>
						<td>
							<div class="text-base-content/80 font-bold">{{ getName(resource) }}</div>
						</td>
						@if (hasTypeBadgeColumn) {
							<td class="hidden md:table-cell">
								@let typeBadge = getTypeBadge(resource);
								@if (typeBadge) {
									<span class="badge badge-ghost badge-sm capitalize">{{ typeBadge }}</span>
								} @else {
									<span class="text-base-content/40">—</span>
								}
							</td>
						}
						@if (hasSizeColumn) {
							<td class="text-base-content/60 hidden text-sm lg:table-cell">
								@let size = getSize(resource);
								@if (size !== null) {
									{{ size | octetHumanReadable }}
								} @else {
									<span class="text-base-content/40">—</span>
								}
							</td>
						}
						@if (hasDateColumn) {
							<td class="text-base-content/60 hidden text-sm lg:table-cell">
								@let date = getDate(resource);
								@if (date) {
									{{ date }}
								} @else {
									<span class="text-base-content/40">—</span>
								}
							</td>
						}
						<td>
							@if (def?.onShare) {
								<button
									class="btn btn-ghost btn-sm btn-square"
									(click)="def!.onShare!(resource); $event.stopPropagation()"
									title="Share"
								>
									<svg
										xmlns="http://www.w3.org/2000/svg"
										fill="none"
										viewBox="0 0 24 24"
										stroke-width="1.5"
										stroke="currentColor"
										class="size-5"
									>
										<path
											stroke-linecap="round"
											stroke-linejoin="round"
											d="M7.217 10.907a2.25 2.25 0 1 0 0 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186 9.566-5.314m-9.566 7.5 9.566 5.314m0 0a2.25 2.25 0 1 0 3.935 2.186 2.25 2.25 0 0 0-3.935-2.186Zm0-12.814a2.25 2.25 0 1 0 3.933-2.185 2.25 2.25 0 0 0-3.933 2.185Z"
										/>
									</svg>
								</button>
							}
						</td>
						<td class="flex gap-2">
							@if (def) {
								@if (def.viewLink) {
									<a
										[routerLink]="def.viewLink(resource)"
										class="btn btn-xs btn-primary"
										(click)="$event.stopPropagation()"
										>View</a
									>
								}

								@if (def.actions) {
									@for (action of def.actions; track action.label) {
										@if (!action.isVisible || action.isVisible(resource)) {
											@if (action.link) {
												<a
													[routerLink]="action.link(resource)"
													class="btn btn-xs"
													[ngClass]="action.styleClass || 'btn-ghost'"
													(click)="$event.stopPropagation()"
													>{{ action.label }}</a
												>
											} @else if (action.onClick) {
												<button
													(click)="action.onClick(resource); $event.stopPropagation()"
													class="btn btn-xs"
													[ngClass]="action.styleClass || 'btn-ghost'"
												>
													{{ action.label }}
												</button>
											}
										}
									}
								}
							}
						</td>
						<td>
							<button
								(click)="$event.stopPropagation()"
								[cdkMenuTriggerFor]="menuItemTpl"
								class="btn btn-square btn-ghost btn-sm"
							>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									fill="none"
									viewBox="0 0 24 24"
									stroke-width="1.5"
									stroke="currentColor"
									class="size-5"
								>
									<path
										stroke-linecap="round"
										stroke-linejoin="round"
										d="M12 6.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5ZM12 12.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5ZM12 18.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5Z"
									/>
								</svg>
							</button>
							<ng-template #menuItemTpl>
								<ul
									class="menu bg-base-100 rounded-box border-base-200 w-56 border p-2 shadow-xl"
									cdkMenu
								>
									<li
										cdkMenuItem
										class="disabled"
									>
										<span class="text-xs opacity-50">ID: {{ resource.id }}</span>
									</li>
								</ul>
							</ng-template>
						</td>
					</tr>
				}
				@if (subfolders().length === 0 && resources().length === 0) {
					<tr>
						<td
							[attr.colspan]="5 + (hasTypeBadgeColumn ? 1 : 0) + (hasSizeColumn ? 1 : 0) + (hasDateColumn ? 1 : 0)"
							class="py-16 text-center opacity-50"
						>
							<div class="flex flex-col items-center gap-2">
								<span class="text-4xl">📂</span>
								<span>Empty folder</span>
							</div>
						</td>
					</tr>
				}
			</tbody>
		</table>
	</div>

	<!-- Preview panel -->
	@if (selectedResource()) {
		<div class="bg-base-100 rounded-box border-base-200 hidden w-80 shrink-0 border shadow md:block lg:w-96">
			<div class="border-base-200 flex items-center justify-between border-b px-4 py-2">
				<span class="text-base-content/60 text-sm font-medium">Preview</span>
				<button
					class="btn btn-ghost btn-sm btn-square"
					(click)="closePreview()"
				>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						fill="none"
						viewBox="0 0 24 24"
						stroke-width="1.5"
						stroke="currentColor"
						class="size-5"
					>
						<path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
					</svg>
				</button>
			</div>
			<div class="max-h-[calc(100vh-16rem)] overflow-y-auto">
				@if (selectedPreviewComponent()) {
					<ng-container *ngComponentOutlet="selectedPreviewComponent(); inputs: { resource: selectedResource() }"></ng-container>
				}
			</div>
		</div>
	}
</div>
